"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = babelHelpers.interopRequireWildcard(require("react"));

var _reactDom = babelHelpers.interopRequireDefault(require("react-dom"));

var _classList = babelHelpers.interopRequireDefault(require("class-list"));

var GMAPI_KEY = 'AIzaSyB-LLp_4J1bcJT0BTEo17yojUGN10MjXLg';
var MAP_SRC = "https://maps.googleapis.com/maps/api/js?key=" + GMAPI_KEY + "&zoom=12&format=png&maptype=roadmap&style=element:geometry%7Ccolor:0xf5f5f5&style=element:labels.icon%7Cvisibility:off&style=element:labels.text.fill%7Ccolor:0x616161&style=element:labels.text.stroke%7Ccolor:0xf5f5f5&style=feature:administrative.land_parcel%7Celement:labels.text.fill%7Ccolor:0xbdbdbd&style=feature:poi%7Celement:geometry%7Ccolor:0xeeeeee&style=feature:poi%7Celement:labels.text.fill%7Ccolor:0x757575&style=feature:poi.park%7Celement:geometry%7Ccolor:0xe5e5e5&style=feature:poi.park%7Celement:labels.text.fill%7Ccolor:0x9e9e9e&style=feature:road%7Celement:geometry%7Ccolor:0xffffff&style=feature:road.arterial%7Celement:labels.text.fill%7Ccolor:0x757575&style=feature:road.highway%7Celement:geometry%7Ccolor:0xdadada&style=feature:road.highway%7Celement:labels.text.fill%7Ccolor:0x616161&style=feature:road.local%7Celement:labels.text.fill%7Ccolor:0x9e9e9e&style=feature:transit.line%7Celement:geometry%7Ccolor:0xe5e5e5&style=feature:transit.station%7Celement:geometry%7Ccolor:0xeeeeee&style=feature:water%7Celement:geometry%7Ccolor:0xc9c9c9&style=feature:water%7Celement:labels.text.fill%7Ccolor:0x9e9e9e&size=480x360&callback=mapLoaded";
var mapLoad = null;

function loadMap() {
  if (!mapLoad) {
    mapLoad = new Promise(function (resolve) {
      window.mapLoaded = function () {
        resolve(true);
      };

      var script = document.createElement('script');
      script.async = true;
      script.src = MAP_SRC;
      document.body.insertBefore(script, document.body.firstChild);
    });
  }

  return mapLoad;
}

var GoogleMap =
/*#__PURE__*/
function (_Component) {
  babelHelpers.inherits(GoogleMap, _Component);

  function GoogleMap(props) {
    var _this;

    babelHelpers.classCallCheck(this, GoogleMap);
    _this = babelHelpers.possibleConstructorReturn(this, babelHelpers.getPrototypeOf(GoogleMap).call(this, props));
    _this.state = {
      map: null,
      coordinates: _this.props.coordinates
    };
    _this.onResize = _this.onResize.bind(babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    _this.gotMapRoot = _this.gotMapRoot.bind(babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    _this.gotMapIcon = _this.gotMapIcon.bind(babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    _this.gotImage = _this.gotImage.bind(babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    _this.loadedImage = _this.loadedImage.bind(babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    _this.recenterMap = _this.recenterMap.bind(babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    GoogleMap.currentInstance = babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this));
    return _this;
  }

  babelHelpers.createClass(GoogleMap, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      window.addEventListener('resize', this.onResize);
      loadMap().then(function () {
        if (!_this2.state.coordinates) {
          _this2.geocode(_this2.props.address).then(function (coordinates) {
            _this2.setState({
              coordinates: coordinates
            }, function () {
              return _this2.setupMap();
            });
          });

          return;
        }

        _this2.setupMap();
      });
    }
  }, {
    key: "geocode",
    value: function geocode(address) {
      return new Promise(function (resolve) {
        var geocoder = new google.maps.Geocoder();
        geocoder.geocode({
          address: address
        }, function (result, status) {
          if (status == google.maps.GeocoderStatus.OK) {
            resolve(result[0].geometry.location);
          } else {
            resolve({
              lat: 0,
              lng: 0
            });
          }
        });
      });
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.onResize);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      if (this.mapRoot && this.state.mapElement && this.state.mapElement.parentNode != this.mapRoot) {
        this.mapRoot.appendChild(this.state.mapElement);
        this.onResize();
      }
    }
  }, {
    key: "onResize",
    value: function onResize() {
      if (this.mapRoot && this.state.mapElement) {
        var centerY = this.mapRoot.offsetHeight / 2;
        var iconCenter = centerY;

        if (this.mapIcon) {
          iconCenter = this.mapIcon.offsetTop + 0.5 * this.mapIcon.offsetHeight;
        }

        var extraSize;
        extraSize = 2 * (iconCenter - centerY);
        this.state.mapElement.style.bottom = "".concat(0 - extraSize, "px");
        google.maps.event.trigger(this.state.map, 'resize');
        requestAnimationFrame(this.recenterMap);
      }
    }
  }, {
    key: "recenterMap",
    value: function recenterMap() {
      var centerY = this.mapRoot.offsetHeight / 2;
      var iconCenter = centerY;

      if (this.mapIcon) {
        iconCenter = this.mapIcon.offsetTop + 0.5 * this.mapIcon.offsetHeight;
      }

      var extraSize;
      extraSize = 2 * (iconCenter - centerY);
      this.state.map.setCenter(this.state.mapOptions.center);
      var nl = this.state.mapElement.querySelectorAll('.gm-style-cc, a[title="Click to see this area on Google Maps"]');

      if (!nl.length) {
        requestAnimationFrame(this.onResize);
      }

      [].forEach.call(nl, function (node) {
        node.style.display = 'block';
        node.style.transform = "translateY(".concat(0 - extraSize, "px)");
      });
    }
  }, {
    key: "setupMap",
    value: function setupMap() {
      var _this3 = this;

      loadMap().then(function () {
        return _this3.setupMapInner();
      });
    }
  }, {
    key: "setupMapInner",
    value: function setupMapInner() {
      var mapCenter = this.state.coordinates;

      if (typeof mapCenter == 'string') {
        mapCenter = mapCenter.split(/\s*,\s*/);
        mapCenter = {
          lat: Number(mapCenter[0]),
          lng: Number(mapCenter[1])
        };
      }

      var mapOptions = {
        center: mapCenter,
        zoom: 17,
        clickableIcons: false,
        disableDefaultUI: true,
        disableDoubleClickZoom: true,
        draggable: false,
        fullscreenControl: false,
        gestureHandling: 'none',
        keyboardShortcuts: false,
        mapTypeControl: false,
        panControl: false,
        rotateControl: false,
        scaleControl: false,
        scrollwheel: false,
        streetViewControl: false,
        zoomControl: false,
        styles: [{
          stylers: [{
            saturation: -100
          }, {
            gamma: 0.8
          }, {
            lightness: 2
          }, {
            visibility: 'on'
          }]
        }]
      };
      var mapElement = document.createElement('div');
      mapElement.className = 'gmap-container';

      if (this.state.mapElement) {
        this.state.mapElement.remove();
      }

      this.mapRoot.appendChild(mapElement);
      var map = new google.maps.Map(mapElement, mapOptions);
      this.setState({
        map: map,
        mapElement: mapElement,
        mapOptions: mapOptions
      });
      this.onResize();
    }
  }, {
    key: "gotMapRoot",
    value: function gotMapRoot(node) {
      var oldMapRoot = this.mapRoot;
      this.mapRoot = node;

      if (oldMapRoot != this.mapRoot) {
        this.setupMap();
      }
    }
  }, {
    key: "gotMapIcon",
    value: function gotMapIcon(node) {
      this.mapIcon = node;

      if (node && this.state.mapElement && this.mapRoot) {
        this.onResize();
      }
    }
  }, {
    key: "gotImage",
    value: function gotImage(node) {
      if (node) {
        if (!node.complete) node.style.display = 'none';
      }

      this.imageNode = node;
    }
  }, {
    key: "loadedImage",
    value: function loadedImage() {
      if (this.imageNode) {
        this.imageNode.style.display = '';
        this.onResize();
      }
    }
  }, {
    key: "render",
    value: function render() {
      return _react.default.createElement("div", {
        className: "map-outer"
      }, _react.default.createElement("div", {
        className: "google-map",
        ref: this.gotMapRoot
      }), _react.default.createElement("div", {
        className: "google-map-overlay"
      }), _react.default.createElement("div", {
        className: "map-item"
      }, _react.default.createElement("div", {
        className: "map-item-inner"
      }, _react.default.createElement("h3", {
        className: "name"
      }, "Park City Cinema"), _react.default.createElement("p", {
        className: "address"
      }, this.props.address), _react.default.createElement("p", {
        className: ""
      }, this.props.addressLink ? _react.default.createElement("a", {
        href: this.props.addressLink,
        target: "_blank",
        className: "btn btn-primary"
      }, "Get Directions") : ''))), _react.default.createElement("div", {
        className: "map-arrow"
      }), _react.default.createElement("div", {
        className: "map-icon",
        ref: this.gotMapIcon
      }));
    }
  }], [{
    key: "show",
    value: function show(address, addressLink, coordinates, parent) {
      _reactDom.default.render(_react.default.createElement(GoogleMap, {
        address: address,
        addressLink: addressLink,
        coordinates: coordinates
      }), parent);
    }
  }]);
  return GoogleMap;
}(_react.Component);

exports.default = GoogleMap;